import React, { Component } from 'react';
import { compose } from 'recompose';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import Pagination from '../../Common/Pagination';
import withReminderListData from './withReminderListData';
import withReminderTypes from './withReminderLisTypes';
import ReminderCard from './ReminderCard'
import AddReminderModal from './AddReminderModal';

class RemindMe extends Component {
  heading() {
    return <div className="remind-me-header">
      <h3><HTMLTrans id="account.dashboard_remind_me">Remind Me</HTMLTrans></h3>
      <hr />
      <HTMLTrans id="account.dashboard_record_dates">
        Record your meaningful dates, and we will be reminding you ahead along with specially curated promotion to celebrate those special days!
      </HTMLTrans>
    </div>
  }

  addButton() {
    return this.props.reminderTypes.length > 0 && <AddReminderModal
      reminderTypes={this.props.reminderTypes}
      refreshList={() => this.props.getListByPage(1)}
    />;
  }

  viewList() {
    const {remindersList} = this.props;

    return <div className="reminders-table">
      {remindersList.map((reminder) => {
        return <ReminderCard 
          key={reminder.id}
          reminder={reminder}
          reminderTypes={this.props.reminderTypes}
          refreshList={() => this.props.getListByPage(1)}
        />
      })}
    </div>
  }

  pagination() {
    const {
      getListByPage,
      lastPage,
      currentPage,
    } = this.props;

    return currentPage && <Pagination
      lastPageNumber={lastPage}
      currentPageNumber={currentPage}
      onClick={getListByPage}
    />
  }

  render() {
    return <div className="dashboard-card p-3 p-lg-5">
      {this.heading()}
      {this.addButton()}
      {this.viewList()}
      {this.pagination()}
    </div>
  }
}

const enhance = compose(
  withTranslationProvider,
  withReminderListData,
  withReminderTypes
)

export default enhance(RemindMe);
export const undecorated = RemindMe;



// WEBPACK FOOTER //
// ./src/Account/RemindMe/RemindMe.js